import React from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import clsx from "clsx";
import styles from "./ActionModal.module.scss";
import { CloseIcon } from "../../icons/CloseIcon";

const ActionModal = ({
  isOpen = false,
  center,
  title,
  titleClassName,
  closeClassName,
  contentClassName,
  description,
  descriptionClassName,
  icon,
  iconClassName,
  children,
  className,
  onDismiss,
  width,
  height,
  dataTestID,
  modalProps = {},
}) => (
  <ReactModal
    isOpen={isOpen}
    overlayClassName={styles.ActionModalOverlay}
    className={`${styles.ActionModalContent} ${contentClassName || ""}`}
    style={{
      content: {
        ...(width && { width }),
        ...(height && { height }),
      },
    }}
    {...modalProps}
  >
    <div
      className={`${styles.ActionModal} ${center ? styles.Center : ""} ${className}`}
      data-testid={dataTestID}
    >
      <div className={`${styles.Close} ${closeClassName || ""}`}>
        <CloseIcon onClick={onDismiss} data-testid="ActionModalDismissButton" />
      </div>
      <h5 data-testid="ActionModalTitle" className={titleClassName}>
        {icon ? <span className={clsx(styles.titleIcon, iconClassName)}>{icon}</span> : null}
        {title}
      </h5>
      {description ? (
        <p data-testid="ActionModalDescription" className={descriptionClassName}>
          {description}
        </p>
      ) : null}
      {children}
    </div>
  </ReactModal>
);

ActionModal.propTypes = {
  isOpen: PropTypes.bool,
  center: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  titleClassName: PropTypes.string,
  closeClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  description: PropTypes.string,
  descriptionClassName: PropTypes.string,
  icon: PropTypes.node,
  iconClassName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  onDismiss: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.number,
  dataTestID: PropTypes.string,
  modalProps: PropTypes.object,
};

ActionModal.defaultProps = {
  isOpen: false,
  modalProps: {},
};

export default ActionModal;
